import React, {Component} from 'react';
import {DialogManager as Dialog} from '@proxibid/proxiponents';

class DialogManager extends Component {
    render() {
        return (
            <Dialog
                {...this.props}
            />
        );
    }
}

export default DialogManager;
